import React from 'react';
import { useLocalAgentStatus } from '../hooks/useLocalAgentStatus';
import { AgentDownloadButton } from './AgentDownloadButton';

export const LocalAgentStatusCard: React.FC = () => {
  const status = useLocalAgentStatus({ intervalMs: 5000, enabled: true });

  const renderBadge = () => {
    switch (status.status) {
      case 'online':
        return (
          <span
            style={{
              display: 'inline-block',
              padding: '0.125rem 0.5rem',
              borderRadius: '9999px',
              backgroundColor: '#16a34a',
              color: '#ffffff',
              fontSize: '0.75rem',
              fontWeight: 600
            }}
          >
            Connected
          </span>
        );
      case 'checking':
        return (
          <span
            style={{
              display: 'inline-block',
              padding: '0.125rem 0.5rem',
              borderRadius: '9999px',
              backgroundColor: '#e5e7eb',
              color: '#111827',
              fontSize: '0.75rem',
              fontWeight: 600
            }}
          >
            Checking...
          </span>
        );
      case 'offline':
      case 'error':
      default:
        return (
          <span
            style={{
              display: 'inline-block',
              padding: '0.125rem 0.5rem',
              borderRadius: '9999px',
              backgroundColor: '#dc2626',
              color: '#ffffff',
              fontSize: '0.75rem',
              fontWeight: 600
            }}
          >
            Not Detected
          </span>
        );
    }
  };

  const renderContent = () => {
    if (status.status === 'checking') {
      return <p>Checking for local SignalBridge Agent...</p>;
    }

    if (status.status === 'online') {
      return (
        <>
          <p style={{ marginTop: '0.5rem', marginBottom: '0.25rem' }}>
            <strong>Version:</strong> {status.version ?? 'Unknown'}
          </p>
          {status.agentId && (
            <p style={{ marginTop: 0, marginBottom: '0.25rem' }}>
              <strong>Agent ID:</strong> {status.agentId}
            </p>
          )}
          {status.tenantId && (
            <p style={{ marginTop: 0, marginBottom: '0.5rem' }}>
              <strong>Tenant:</strong> {status.tenantId}
            </p>
          )}

          {status.isOutdated && (
            <div
              style={{
                marginTop: '0.5rem',
                padding: '0.5rem 0.75rem',
                borderRadius: '0.375rem',
                backgroundColor: '#fef3c7',
                color: '#92400e',
                border: '1px solid #fcd34d'
              }}
            >
              <p style={{ margin: 0, marginBottom: '0.5rem', fontWeight: 600 }}>
                Update Required
              </p>
              <p style={{ margin: 0, marginBottom: '0.5rem', fontSize: '0.875rem' }}>
                A newer version of the SignalBridge Agent is available. Please
                download and install the latest version.
              </p>
              <AgentDownloadButton variant="primary" />
            </div>
          )}
        </>
      );
    }

    // offline or error
    return (
      <>
        <p style={{ marginTop: '0.5rem', marginBottom: '0.75rem' }}>
          Agent is not running on this machine.
        </p>
        <AgentDownloadButton variant="primary" />
      </>
    );
  };

  return (
    <div
      style={{
        borderRadius: '0.5rem',
        border: '1px solid #e5e7eb',
        padding: '1rem',
        backgroundColor: '#ffffff',
        boxShadow:
          '0 1px 2px 0 rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.1)',
        maxWidth: '420px'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '0.25rem'
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: '1rem',
            fontWeight: 600,
            color: '#111827'
          }}
        >
          Local SignalBridge Agent
        </h3>
        {renderBadge()}
      </div>

      {status.lastChecked && (
        <p
          style={{
            margin: 0,
            marginBottom: '0.5rem',
            fontSize: '0.75rem',
            color: '#6b7280'
          }}
        >
          Last checked: {status.lastChecked.toLocaleTimeString()}
        </p>
      )}

      {renderContent()}
    </div>
  );
};
